module.exports = __webpack_public_path__ + "img/driver.6b38917c.svg";